module.exports = __webpack_public_path__ + "img/folder_open.0239d259.png";